<script lang="ts">
import EmployeeFormGroup from "$lib/partials/EmployeeFormGroup.svelte";
import EmployeeWidget from "$lib/partials/EmployeeWidget.svelte";
import {onMount} from "svelte";
import {getReference} from "$lib/calls/hr";
import {get} from "$lib/api";
import AddButton from "$lib/components/ui/AddButton.svelte";
import {Button} from "flowbite-svelte";
import {PlusOutline} from "flowbite-svelte-icons";

export let editing = false;
export let employee;

let graduationOptions: Array<any> = [];
let educationOptions: Array<any> = [];

let statusOptions = [
    {name: 'Neue Bewerbung', value: 'candidate'},
    {name: 'Telefontermin gebucht', value: 'interviewee'},
    {name: 'Im Bewerbungsprozess', value: 'onboarding'},
    {name: 'Aktiv', value: 'active'},
    {name: 'Inaktiv', value: 'inactive'},
    {name: 'Freigestellt', value: 'sabbatical'},
]
let shirtSizeOptions = [
    {name: 'XXS', value: 'xxs'},
    {name: 'XS', value: 'xs'},
    {name: 'S', value: 's'},
    {name: 'M', value: 'm'},
    {name: 'L', value: 'l'},
    {name: 'XL', value: 'xl'},
    {name: 'XXL', value: 'xxl'},
]
let pantsSizeOptions = [
    {name: 'XXS', value: 'xxs'},
    {name: 'XS', value: 'xs'},
    {name: 'S', value: 's'},
    {name: 'M', value: 'm'},
    {name: 'L', value: 'l'},
    {name: 'XL', value: 'xl'},
    {name: 'XXL', value: 'xxl'},
]
let shoeSizeOptions = [
    {name: 33, value: 33},
    {name: 34, value: 34},
    {name: 35, value: 35},
    {name: 36, value: 36},
    {name: 37, value: 37},
    {name: 38, value: 38},
    {name: 39, value: 39},
    {name: 40, value: 40},
    {name: 41, value: 41},
    {name: 42, value: 42},
    {name: 43, value: 43},
    {name: 44, value: 44},
    {name: 45, value: 45},
    {name: 46, value: 46},
    {name: 47, value: 47},
    {name: 48, value: 48}
]

let motorVehicleLicenseOptions = [
    {name: 'Kein Führerschein', value: '0'},
    {name: 'Klasse B', value: 'car'},
]

let languages = [];

onMount(async () => {
    graduationOptions = (await getReference('Schulabschluss')).map(x => ({ name: x.value, value: x.key }));
    educationOptions = (await getReference('Ausbildung')).map(x => ({ name: x.value, value: x.key }));
    const languageList = await get('/i18n/languages') //.map((x,iso) => ({value: iso, name: x[iso].name}))
    languages = Object.keys(languageList).map(key => ({name: languageList[key].name + ' | ' + languageList[key].nativeName,  value: key}))
})

</script>

<EmployeeWidget headline="Schulabschluss / Ausbildung / Sedcard" collapsible open={false}>

    <svelte:fragment slot="left">
        <EmployeeFormGroup
                {editing}
                label="Schulabschluss"
                labelFor="graduation"
                data={graduationOptions}
                bind:value={employee.cv.graduation}>
            {graduationOptions.find(option => option.name === employee.cv.graduation || '')?.name || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                bind:value={employee.cv.workExperiences}
                label="Bisherige Tätigkeiten"
                labelFor="profession">
            {employee.cv.workExperiences || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Aktueller Status"
                labelFor="status"
                bind:value={employee.cv.currentStatus}>
            {employee.cv.currentStatus || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Ausbildung"
                labelFor="education"
                data={educationOptions}
                bind:value={employee.cv.graduation}>
            {employee.cv.graduation || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Referenzen"
                bind:value={employee.reference}
                labelFor="references">
            {employee.reference || '-'}
        </EmployeeFormGroup>
        <EmployeeFormGroup
                {editing}
                label="Führerschein"
                data={motorVehicleLicenseOptions}
                value={employee.cv.motorVehicleLicense}
                extract={selected => employee.cv.motorVehicleLicense = selected.value}
                labelFor="driversLicense">
            {motorVehicleLicenseOptions.find(option => option.value === employee.cv.motorVehicleLicense || '')?.name || '-'}
        </EmployeeFormGroup>

    </svelte:fragment>

    <svelte:fragment slot="right">



        {#each employee.languages as employeeLanguage}
            <EmployeeFormGroup
                    {editing}
                    label="Sprache"
                    value={employeeLanguage.languageIsoCode}
                    data={languages}
                    extract={selected => employeeLanguage.languageIsoCode = selected.value}
                    labelFor="languages">
                {languages.find(x => x.value === employeeLanguage.languageIsoCode)?.name || ''}
            </EmployeeFormGroup>
        {/each}
        {#if editing}
            <Button size="xs" on:click={() => employee.languages = [...employee.languages, {languageIsoCode: '', employeeId: employee.id}]}>
                <PlusOutline class="w-3 h-3 mr-2"/>
                <span>Sprache hinzufügen</span>
            </Button>
        {/if}

        <EmployeeFormGroup
                {editing}
                label="Hemdgröße (Intl)"
                labelFor="shirtSize"
                extract={selected => employee.cv.shirtSize = selected.name}
                data={shirtSizeOptions}>
            {employee.cv.shirtSize || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Hosengröße (Intl)"
                labelFor="pantsSize"
                data={pantsSizeOptions}
                extract={selected => employee.cv.pantsSize = selected.name}>
            {employee.cv.pantsSize || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Schuhgröße (EU)"
                labelFor="shoeSize"
                data={shoeSizeOptions}
                extract={selected => employee.cv.shoeSize = selected.value}>
            {employee.cv.shoeSize || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Sonstige Besonderheiten"
                bind:value={employee.cv.note}
                labelFor="specials">
            {employee.note || '-'}
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Körpergröße"
                labelFor="bodySize">
            {employee.cv.height || '-'} cm
        </EmployeeFormGroup>

        <EmployeeFormGroup
                {editing}
                label="Haarfarbe"
                labelFor="hairColor">
            {employee.cv.hairColor || '-'}
        </EmployeeFormGroup>

    </svelte:fragment>

</EmployeeWidget>